import { withLiteObserverAndTheme } from "../../../../../../../core/et3-enhanced-render";
import Et3Text from "../../../../../../../core/et3-text";

const CreatedOn = withLiteObserverAndTheme<{
  createdOn: string;
  isKhattabaMessage: boolean;
}>((props) => {
  const { createdOn, isKhattabaMessage, theme } = props;
  const { unitX, colors } = theme;
  const textColor = isKhattabaMessage ? colors.all.black : colors.all.white;

  return (
    <Et3Text
      fontFamily={"LIGHT"}
      fontSize={16}
      isSpan={false}
      text={createdOn}
      style={{ width: 160 * unitX }}
      color={textColor}
    />
  );
});

export default CreatedOn;
